/* tslint:disable */
/* eslint-disable */
/**
 * Risks API
 * API for managing risks.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PersonDto } from './PersonDto';
import {
    PersonDtoFromJSON,
    PersonDtoFromJSONTyped,
    PersonDtoToJSON,
    PersonDtoToJSONTyped,
} from './PersonDto';
import type { QuestionAnswerDto } from './QuestionAnswerDto';
import {
    QuestionAnswerDtoFromJSON,
    QuestionAnswerDtoFromJSONTyped,
    QuestionAnswerDtoToJSON,
    QuestionAnswerDtoToJSONTyped,
} from './QuestionAnswerDto';

/**
 * 
 * @export
 * @interface GetUnemploymentRiskResponse
 */
export interface GetUnemploymentRiskResponse {
    /**
     * 
     * @type {string}
     * @memberof GetUnemploymentRiskResponse
     */
    type: string;
    /**
     * 
     * @type {PersonDto}
     * @memberof GetUnemploymentRiskResponse
     */
    person?: PersonDto;
    /**
     * 
     * @type {Array<QuestionAnswerDto>}
     * @memberof GetUnemploymentRiskResponse
     */
    surveyAnswers?: Array<QuestionAnswerDto>;
}

/**
 * Check if a given object implements the GetUnemploymentRiskResponse interface.
 */
export function instanceOfGetUnemploymentRiskResponse(value: object): value is GetUnemploymentRiskResponse {
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function GetUnemploymentRiskResponseFromJSON(json: any): GetUnemploymentRiskResponse {
    return GetUnemploymentRiskResponseFromJSONTyped(json, false);
}

export function GetUnemploymentRiskResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUnemploymentRiskResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'person': json['person'] == null ? undefined : PersonDtoFromJSON(json['person']),
        'surveyAnswers': json['surveyAnswers'] == null ? undefined : ((json['surveyAnswers'] as Array<any>).map(QuestionAnswerDtoFromJSON)),
    };
}

export function GetUnemploymentRiskResponseToJSON(json: any): GetUnemploymentRiskResponse {
    return GetUnemploymentRiskResponseToJSONTyped(json, false);
}

export function GetUnemploymentRiskResponseToJSONTyped(value?: GetUnemploymentRiskResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'person': PersonDtoToJSON(value['person']),
        'surveyAnswers': value['surveyAnswers'] == null ? undefined : ((value['surveyAnswers'] as Array<any>).map(QuestionAnswerDtoToJSON)),
    };
}

